import React from 'react';
import { Box, Grid, Typography, IconButton, Container } from '@mui/material';
import { Facebook, Twitter, Instagram, YouTube } from '@mui/icons-material';
import useResponsive from '../hooks/useResponsive';
import { useNavigate } from 'react-router-dom';

const Footer = () => {
    const { isSmallScreen } = useResponsive();
    const navigate = useNavigate();
    return (
        <>

            <Box sx={{ bgcolor: '#41464d', color: '#fff', }}>
                <Container maxWidth="xl" sx={{ px: { xs: 4, md: 10 }, py: 6 }}>
                    {/* Top 6 Columns */}
                    <Grid container spacing={4} justifyContent="space-between">
                        <Grid size={{ xs: 12, sm: 6, md: 2 }}>
                            <Typography variant="h5" fontWeight={600} mb={2}>Builders</Typography>
                            <Typography variant="body2" mb={1}>Vibrant </Typography>
                            <Typography variant="body2" mb={1}>Unitech</Typography>
                            <Typography variant="body2" mb={1}>Ansal API</Typography>
                            <Typography variant="body2" mb={1}>Amrapali Group</Typography>
                            <Typography variant="body2">Builders in India</Typography>
                        </Grid>

                        <Grid size={{ xs: 12, sm: 6, md: 2 }}>
                            <Typography variant="h5" fontWeight={600} mb={2}>Real Estate in Hyderabad</Typography>
                            <Typography variant="body2" mb={1}>Property in Kokapeta</Typography>
                            <Typography variant="body2" mb={1}>Property in Rajendaranagar</Typography>
                            <Typography variant="body2" mb={1}>Property in Kompally</Typography>
                            <Typography variant="body2" mb={1}>Property in Bachupally</Typography>
                            <Typography variant="body2">Cities in Hitech City</Typography>
                        </Grid>

                        <Grid size={{ xs: 12, sm: 6, md: 2 }}>
                            <Typography variant="h5" fontWeight={600} mb={2}>Properties in India</Typography>
                            <Typography variant="body2" mb={1}>Apartments For Sale</Typography>
                            <Typography variant="body2" mb={1}>Ready To Move Apartments</Typography>
                            <Typography variant="body2" mb={1}>Under Construction Property</Typography>
                            <Typography variant="body2" mb={1}>Plot For Sale In India</Typography>
                            <Typography variant="body2">Ongoing Projects in India</Typography>
                        </Grid>

                        <Grid size={{ xs: 12, sm: 6, md: 2 }}>
                            <Typography variant="h5" fontWeight={600} mb={2}>Buy Property</Typography>
                            <Typography variant="body2" mb={1}>Properties For Sale In Shadnagar</Typography>
                            <Typography variant="body2" mb={1}>Properties For Sale In Shamshabad</Typography>
                            <Typography variant="body2" mb={1}>Properties For Sale In Shameerpet</Typography>
                            <Typography variant="body2" mb={1}>Properties For Sale In Patancheru</Typography>
                            <Typography variant="body2">Properties For Sale In Kokapet</Typography>
                        </Grid>

                        <Grid size={{ xs: 12, sm: 6, md: 2 }}>
                            <Typography variant="h5" fontWeight={600} mb={2}>Property Type</Typography>
                            <Typography variant="body2" mb={1}>Apartments sale in Gachibowli</Typography>
                            <Typography variant="body2" mb={1}>Property sale in Begumpet</Typography>
                            <Typography variant="body2" mb={1}>Villas sale in Secunderabad</Typography>
                            <Typography variant="body2" mb={1}>Plots sale in Rajendranagar</Typography>
                            <Typography variant="body2">New apartments for Shadnagar</Typography>
                        </Grid>
                    </Grid>



                    {/* About and Layout */}
                    <Grid container mt={6} sx={{ display: 'flex', justifyContent: 'space-between' }} >
                        {/* About Section */}
                        <Grid size={{ xs: 12, sm: 6, md: 4.7 }}>
                            <Typography variant="h5" fontWeight={600} mb={1}>About Vibrant PropMart</Typography>
                            <Typography variant="body2" lineHeight={1.8} sx={{ color: "#ddd", maxWidth: 400 }}>
                                Vibrant PropMart is one of India's premier digital real estate advisory firms, providing a comprehensive platform for purchasing residential properties.
                                Established in 2011 with the mission of helping individuals find their ideal homes, Vibrant PropMart harnesses the power of information and
                                its extensive expertise in the real estate sector to introduce simplicity, transparency, and trust into the home-buying journey.

                            </Typography>
                        </Grid>

                        {/* Bottom Row  */}

                        {/* Quick Links */}
                        <Grid size={{ xs: 12, sm: 6, md: 2 }}>
                            <Typography variant="h5" fontWeight={600} mb={2}>Quick Links</Typography>
                            <Typography variant="body2" mb={1} onClick={() => navigate("/")}>Home</Typography>
                            <Typography variant="body2" mb={1} >User Agreement</Typography>
                            <Typography variant="body2" mb={1} onClick={() => navigate("/aboutus")}>About us</Typography>
                            <Typography variant="body2" mb={1}>Careers</Typography>
                            <Typography variant="body2" mb={1}>Vibrant guide</Typography>
                            <Typography variant="body2" onClick={() => navigate("/contactus")}>Contact us</Typography>
                        </Grid>

                        {/* Resources */}
                        <Grid size={{ xs: 12, sm: 6, md: 2 }} pl={isSmallScreen ? 0 : 2} >
                            <Typography variant="h5" fontWeight={600} mb={2}>Resources</Typography>
                            <Typography variant="body2" mb={1}>Home Loan</Typography>
                            <Typography variant="body2" mb={1}>NRI Services</Typography>
                            <Typography variant="body2" mb={1}>How To Buy</Typography>
                            <Typography variant="body2" mb={1}>Privacy policy</Typography>
                            <Typography variant="body2" mb={1}>Annual Return</Typography>
                            <Typography variant="body2">Get Home Loan</Typography>
                        </Grid>

                        {/* Network Sites + Follow Us in Column */}
                        <Grid size={{ xs: 12, sm: 6, md: 2 }} pl={isSmallScreen ? 0 : 3} >
                            <Box>
                                <Typography variant="h5" fontWeight={600} mb={2}>Network Sites</Typography>
                                <Typography variant="body2" mb={1}>
                                    <a href="https://www.housing.com" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: 'inherit' }}>
                                        Housing.com
                                    </a>
                                </Typography>
                                <Typography variant="body2" mb={1}>
                                    <a href="https://www.realestate.com.au" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: 'inherit' }}>
                                        Realestate.com.au
                                    </a>
                                </Typography>
                                <Typography variant="body2">
                                    <a href="https://www.realtor.com" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: 'inherit' }}>
                                        Realtor.com
                                    </a>
                                </Typography>
                            </Box>

                            <Box>
                                <Typography variant="h5" fontWeight={600} mt={2.5}>Follow Us</Typography>
                                <Box gap={1}>
                                    <IconButton sx={{ color: '#fff' }}><Facebook /></IconButton>
                                    <IconButton sx={{ color: '#fff' }}><Twitter /></IconButton>
                                    <IconButton sx={{ color: '#fff' }}><Instagram /></IconButton>
                                    <IconButton sx={{ color: '#fff' }}><YouTube /></IconButton>
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>



                    {/* Footer Bottom */}
                    <Box mt={5} pt={3} borderTop="1px solid #5b5f65" display="flex" justifyContent="space-between" flexWrap="wrap">
                        <Typography variant="body2" sx={{ color: '#bbb' }}>
                            © 2025 All rights reserved by Vibrant PropMart
                        </Typography>
                        <Typography variant="body2" sx={{ color: '#bbb' }}>
                            Designed & Developed by Abilio IT Solutions
                        </Typography>
                    </Box>
                </Container>
            </Box >
        </>
    );
};

export default Footer;
